// removed by extract-text-webpack-plugin
module.exports = {"container":"container___35dJU","header":"header___EbSSE","description":"description___1Fj2Z"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/CollectionList/CollectionList.module.css
// module id = 392
// module chunks = 0